import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export const uploadFile = async (file, onProgress) => {
  const form = new FormData();
  form.append("file", file);
  const { data } = await api.post("/upload", form, {
    headers: { "Content-Type": "multipart/form-data" },
    onUploadProgress: (e) => {
      if (onProgress && e.total) onProgress(Math.round((e.loaded * 100) / e.total));
    },
  });
  return data;
};

export const createRequest = async (payload) => {
  const { data } = await api.post("/requests", payload);
  return data;
};

export const getRequest = async (ref) => {
  const { data } = await api.get(`/requests/${ref}`);
  return data;
};

export const listRequests = async (status, search) => {
  const { data } = await api.get("/requests", { params: { status, search } });
  return data;
};

export const getStats = async () => {
  const { data } = await api.get("/requests/stats");
  return data;
};

export const updateStatus = async (id, status) => {
  const { data } = await api.patch(`/requests/${id}/status`, { status });
  return data;
};

export const addNote = async (id, text) => {
  const { data } = await api.post(`/requests/${id}/notes`, { text });
  return data;
};

export const sendQuotation = async (id, amount, message, file) => {
  const form = new FormData();
  form.append("amount", amount);
  form.append("message", message || "");
  if (file) form.append("file", file);
  const { data } = await api.post(`/requests/${id}/quotation`, form, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return data;
};

export const fileUrl = (storagePath) => `${API}/files/${storagePath}`;

export const verifyAdminCode = async (code) => {
  const { data } = await api.post("/admin/verify", { code });
  return data;
};

export const adminLogin = async (email, password) => {
  const { data } = await api.post("/admin/login", { email, password });
  return data;
};

export const updateCredentials = async (payload) => {
  const { data } = await api.put("/admin/credentials", payload);
  return data;
};

export const deleteRequest = async (id) => {
  const { data } = await api.delete(`/requests/${id}`);
  return data;
};

export const createInquiry = async (payload) => {
  const { data } = await api.post("/inquiries", payload);
  return data;
};

export const listInquiries = async (status, search) => {
  const { data } = await api.get("/inquiries", { params: { status, search } });
  return data;
};

export const getInquiryStats = async () => {
  const { data } = await api.get("/inquiries/stats");
  return data;
};

export const updateInquiryStatus = async (id, status) => {
  const { data } = await api.patch(`/inquiries/${id}/status`, { status });
  return data;
};

export const deleteInquiry = async (id) => {
  const { data } = await api.delete(`/inquiries/${id}`);
  return data;
};

export const getSiteContact = async () => {
  const { data } = await api.get("/site-contact");
  return data;
};

export const updateSiteContact = async (payload) => {
  const { data } = await api.put("/site-contact", payload);
  return data;
};

export const getSiteImages = async () => {
  const { data } = await api.get("/site-images");
  return data;
};

export const setSiteImage = async (key, fileref) => {
  const { data } = await api.put(`/site-images/${key}`, fileref);
  return data;
};

export const deleteSiteImage = async (key) => {
  const { data } = await api.delete(`/site-images/${key}`);
  return data;
};

export const getProjects = async () => {
  const { data } = await api.get("/projects");
  return data;
};

export const updateProject = async (cat, payload) => {
  const { data } = await api.put(`/projects/${cat}`, payload);
  return data;
};
